"use strict";
/* eslint-disable no-bitwise */var urlAlphabet="ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW",nanoid=function(r){for(var a="",n=r=void 0===r?21:r;n--;)a+=urlAlphabet[64*Math.random()|0];return a};
/** Создание уникального ключа
 *
 * @param {number} size - длина уникального ключа
 */module.exports=nanoid;
